export const UPLOAD_IMAGE_FILE = "UPLOAD_IMAGE_FILE";
export const RESET_IMAGE_STORE = "RESET_IMAGE_STORE";
